<my-modal #deletionModal [useCustomFooter]="true" [classes]="['modal-lg']">
  <div modal-title class="tw-text-xl">Delete Option</div>
  <div modal-body>
    <div class="tw-text-lg tw-mb-1">Are you sure you want to delete this option?</div>
  </div>
  <div modal-footer>
    <button
      class="btn btn-default"
      (click)="closeModal()"
    >
      Cancel
    </button>
    <button
      class="btn btn-primary"
      (click)="deleteOption()"
      [disabled]="false"
    >
      Yes
    </button>

  </div>
</my-modal>
